// extracted by mini-css-extract-plugin
module.exports = {"hero":"HeroFooter_hero_29R4b","text":"HeroFooter_text_1yxwF","link":"HeroFooter_link_Y0CYf","button":"HeroFooter_button_18-UJ"};